"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowGoback = function ArrowGoback() {
  return _react2.default.createElement(
    "g",
    { id: "back_arrow" },
    _react2.default.createElement("polygon", {
      id: "arrow-goback",
      transform: "translate(250.000000, 249.846154) rotate(-180.000000) translate(-250.000000, -249.846154) ",
      points: "417.030692 226.886338 0 226.886338 0 272.822043 417.015408 272.822043 323.133188 371.54535 353.71179 403.692308 500 249.846154 353.71179 96 323.133188 128.146958"
    })
  );
};

exports.default = ArrowGoback;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/ArrowGoback.js
// module id = 2922
// module chunks = 4